import { createReducer, on } from '@ngrx/store';
import { setTargetRatesShowRecessions } from './show-recessions.actions';
export const showRecessions = createReducer(false, on(setTargetRatesShowRecessions, (state, action) => {
    return action.showRecessions;
}));
